// The loading mascot is drawn up to three times in a row (index.html,
// RouteFallback, then HomeV1's loader). Each new copy's CSS animation would start
// from its first frame and the mascot would jump back, so pin every copy to the
// start of the page timeline and they move as one continuous animation.
const LOADER_ANIMATIONS = ["move", "drop", "boot-splash-in"];

export const syncLoaderAnimation = () => {
  if (!document.getAnimations) return;
  document.getAnimations().forEach((animation) => {
    if (LOADER_ANIMATIONS.includes(animation.animationName)) {
      animation.startTime = 0;
    }
  });
};
